<template>
    <section>
            <el-cascader
                v-model="address_data"
                :options ='provinceList'
                @active-item-change="addressChange"
                @change="addressChangeData"
                :props="addressProps"
				 
            ></el-cascader>
    </section>
</template>

<script>
    export default {
        name:'region',
        props: ['addr'],
        data() {
            return {
                province_index:'',
                city_index:'',
                address_data: [],
                provinceList:[],
                cityList:[],
                areaList:[],
                address_data_name:'',
                addressProps:{
                    value:'region_id',
                    children:'childrenList',
                    label:'region_name',
                },
                visible:false,
                mobile:'',
            };
        },
        //初始化方法
        created:function(){
            if (this.addr != undefined && this.addr.length != 0) {
                this.getProvinceData(1).then(val => {
                    if (val) {
                        this.getCityData(this.addr[0]).then(flag => {
                            if (flag) {
                                this.getAreaData(this.addr[1]);
                                this.address_data = this.addr;
                            }
                        });
                    }
                })
            } else {
                this.getProvinceData(1);
            }
        },
        methods:{
            addressChange(val){
                if(val.length == 1){
                    this.getCityData(val[0]);
                }else{
                    this.getAreaData(val[1]);
                }
                this.$emit('address',val);
            },
            addressChangeData(val){
                var address_name = '';
                this.provinceList.forEach((temp)=>{
                    if(temp.region_id === val[0]){
                        address_name = temp.region_name;
                    }
                });
                this.cityList.forEach((temp)=>{
                    if(temp.region_id === val[1]){
                        address_name += temp.region_name;
                    }
                });
                this.areaList.forEach((temp)=>{
                    if(temp.region_id === val[2]){
                        address_name += temp.region_name;
                    }
                });
                this.address_data_name = address_name;
                this.address_data = val;
                this.$emit('address',this.address_data,this.address_data_name);
            },
            getProvinceData(parent_id){
                var regionParams = {
                    'method' :'com.get.basic.common.region.list',
                    'x_account_type':'common',
                    'data':{
                        'parent_id':parent_id
                    }
                };
                return new Promise((resolve,reject) => {
                    this.$ajax(regionParams).then(res => {
                        if(res.status === 10000){
                            res.data.list.forEach((temp) =>{
                                this.provinceList.push({
                                    'region_id':temp.region_id,
                                    'region_name':temp.region_name,
                                    'childrenList':[],
                                });
                            });
                            resolve(true)
                        }else{
                            reject(false)
                            this.$message.error(res.info);
                        }
                    });
                })
                
            },
            getCityData(parent_id){
                var regionParams = {
                    'method' :'com.get.basic.common.region.list',
                    'x_account_type':'common',
                    'data':{
                        'parent_id':parent_id
                    }
                };
                return new Promise((resolve,reject) => {
                    this.$ajax(regionParams).then(res => {
                        if(res.status === 10000){
                            var tempList = [];
                            res.data.list.forEach((temp) =>{
                                tempList.push({
                                    'region_id':temp.region_id,
                                    'region_name':temp.region_name,
                                    'childrenList':[],
                                });
                            });
                            var vue = this;
                            this.cityList = tempList;
                            this.provinceList.forEach((provinceTemp,ind,arr) =>{
                                if(provinceTemp.region_id === parent_id){
                                    vue.provinceList[ind].childrenList = tempList;
                                    vue.province_index = ind;
                                }
                            });
                            resolve(true);
                        }else{
                            this.$message.error(res.info);
                            reject(false)
                        }
                    });
                });
            },
            getAreaData(parent_id){
                var regionParams = {
                    'method' :'com.get.basic.common.region.list',
                    'x_account_type':'common',
                    'data':{
                        'parent_id':parent_id
                    }
                };
                this.$ajax(regionParams).then(res => {
                    if(res.status === 10000){
                        var tempList = [];
                        res.data.list.forEach((temp) =>{
                            tempList.push({
                                'region_id':temp.region_id,
                                'region_name':temp.region_name,
                            });
                        });
                        var vue = this;
                        this.cityList.forEach((cityTemp,ind,arr) =>{
                            if(cityTemp.region_id === parent_id){
                                var provinceModel = vue.provinceList[vue.province_index];
                                var cityModel = provinceModel.childrenList[ind];
                                cityModel.childrenList = tempList;
                            }
                        });
                    }else{
                        this.$message.error(res.info);
                    }
                });
            },
        }
    }

</script>

<style lang="scss" scoped>
    /*全局*/
    a{font-style:normal;color:#333;text-decoration:none;-webkit-tap-highlight-color:rgba(255,0,0,0);}
    ul,li{list-style-type: none;}
    input,button,select,textarea{outline: none;}
    img{border:0;max-width:100%;}
    h4{font-weight:normal;}
    .fl{float:left;}
    .fr{float:right;}

    .pa_login_ma_box{height:50px;line-height:50px;margin-top:5px;text-align:center;background:#f8f8f8;}
    .login_box{padding:40px;}
    .login_box .content{max-width:1000px;margin:0 auto;overflow:hidden;margin-top:6%;}
    .head_box{overflow:hidden;display:flex;max-width:1200px;margin:0 auto;}
    .head_box .txt{display:block;padding-left:60px;font-size:20px;font-weight:400;line-height:46px;position:relative;}
    .head_box .txt::after{content:'';width:1px;height:40px;background:#ccc;position:absolute;left:30px;top:0;}
    .login_form_box{box-sizing:initial;width:310px;margin:10px 10px 10px 10%;padding:60px 40px;border:solid 1px #e5e5e5;box-shadow:0 1px 5px rgba(0,0,0,.1);font-weight:400;}
    .login_form_box dd{overflow:hidden;}
    .login_form_box .col,.agent_form_box .col{width:100%;margin-bottom:20px;padding:0;display:flex;position:relative;}
    .login_form_box .ipt{width:100%;height:40px;padding:0 10px;border:solid 1px #e5e5e5;}
    .login_form_box .btns,.agent_form_box .btns{height:40px;width:100%;background:#FF700B;color:#fff;border:0;}
    .login_form_box .link_btn{display:block;color:#FF700B;font-size:12px;}
    .login_form_box .new_img{display:block;height:50px;margin:-20px 0 18px 0;line-height:50px;background:#E5E5E5;text-align:center;}
    .login_banner{width:40%;margin-top:80px;text-align:center;color:#000;}
    .login_banner .tle{font-size:18px;}
    .login_banner .ts{font-size:14px;color:#9B9B9B;}
    .login_banner .imgs{display:block;margin:20px auto 0;}
    .login_form_box .col .ma{height:38px;width:80px;border:0;padding:0 5px;color:#FF700B;position:absolute;top:1px;right:1px;z-index:9;font-size:12px;background:transparent;}

    @media (max-width:800px){
        .login_banner{float:inherit;width:100%;margin:40px auto 0;}
        .content .form{display:flex;overflow:hidden;width:100%;}
        .login_box{padding:20px;}
        .login_form_box{float:inherit;margin:0 auto;padding:30px 20px;width:70%;}
    }
    @media (max-width:640px){
        .login_form_box{width:96%;}
        .login_form_box{padding:0;border:0;box-shadow: none;}
    }
    @media (max-width:350px){
        .login_form_box .link_btn{float:inherit;margin-bottom:10px;}
    }

    .el-cascader .el-input .el-input_inner{
        width:300px;
    }

</style>


// WEBPACK FOOTER //
// region.vue?5bdfdd5d